import type { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description?: string
  action?: {
    label: string
    onClick: () => void
  }
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-10 px-6 text-center animate-scale-in">
      <div className="mb-3 p-3.5 rounded-2xl bg-gradient-to-br from-primary-50 to-accent-50 dark:from-primary-900/30 dark:to-accent-900/30">
        <Icon size={32} className="text-primary-400 dark:text-primary-500" />
      </div>
      <p className="text-[13px] font-semibold text-neutral-500 dark:text-neutral-400">
        {title}
      </p>
      {description && (
        <p className="text-[11px] text-neutral-400 dark:text-neutral-500 mt-1 max-w-[200px]">
          {description}
        </p>
      )}
      {action && (
        <button
          onClick={action.onClick}
          className="mt-3 px-3 py-1.5 text-[11px] font-medium text-primary-600 dark:text-primary-400 bg-primary-50 dark:bg-primary-900/20 rounded-lg hover:bg-primary-100 dark:hover:bg-primary-900/30 active:scale-95 transition-all"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
